import { render } from "./Chapter.vue?vue&type=template&id=0561a542&ts=true"
import script from "./Chapter.vue?vue&type=script&lang=ts"
export * from "./Chapter.vue?vue&type=script&lang=ts"

import "./Chapter.vue?vue&type=style&index=0&id=0561a542&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__